document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const drawer = document.querySelector('[data-mobile-drawer]');
    drawer?.classList.toggle('is-active');
  }

  const ageAccept = event.target.closest('[data-age-accept]');
  if (ageAccept) {
    localStorage.setItem('chilla_age_verified', 'true');
    document.querySelector('[data-age-gate]')?.classList.remove('is-active');
  }

  const ageLeave = event.target.closest('[data-age-leave]');
  if (ageLeave) {
    window.location.href = 'https://www.google.com';
  }

  const qtyButton = event.target.closest('[data-qty]');
  if (qtyButton) {
    const wrapper = qtyButton.closest('[data-quantity]');
    const input = wrapper?.querySelector('input');
    if (!input) return;
    const direction = qtyButton.getAttribute('data-qty');
    const current = Number(input.value || 1);
    input.value = direction === 'plus' ? current + 1 : Math.max(1, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

window.addEventListener('DOMContentLoaded', () => {
  const gate = document.querySelector('[data-age-gate]');
  if (gate && localStorage.getItem('chilla_age_verified') !== 'true') {
    gate.classList.add('is-active');
  }
});
